// @flow
import { createAction } from 'redux-actions';
import {
    SET_ALL_TASKS_COUNT,
    SET_MY_TASKS_COUNT,
    SET_ALL_COMMUNICATION_TASKS_COUNT,
    SET_MY_COMMUNICATION_TASKS_COUNT,
} from './constants';

export const setAllTasksCount = createAction(SET_ALL_TASKS_COUNT);
export const setMyTasksCount = createAction(SET_MY_TASKS_COUNT);
export const setAllCommunicationTasksCount = createAction(SET_ALL_COMMUNICATION_TASKS_COUNT);
export const setMyCommunicationTasksCount = createAction(SET_MY_COMMUNICATION_TASKS_COUNT);
